var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Faq"}},[_c('h1',[_vm._v("Frequently Asked Questions")]),_c('div',{staticClass:"line"}),_c('div',{attrs:{"id":"accordionContainer"}},[_c('Accordion',{attrs:{"accordionData":_vm.accordionData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }